import BaseReducer from "./BaseReducer";

class MergeCustomersModalReducer extends BaseReducer {
  domain = "Modals";
  type = "MergeCustomersModal";

  initialState = {
    open: false,
    primaryCustomer: null,
    onMergeComplete: null,
  };
}

const reducer = new MergeCustomersModalReducer();

export default reducer;
